import { CommonModule, DatePipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormsModule } from '@angular/forms';
import { NgbModal, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PayrollsService } from '@services/payrolls.service';
import { ReportService } from '@services/report.service';
import { NumberPipe } from 'app/pipes/number.pipe';
import { ReviewPayrollComponent } from '../review-payroll/review-payroll.component';
import { ReviewRequestComponent } from '@components/requests/review-request/review-request.component';
import { UserService } from '@services/core/user.service';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { RequestInsuredService } from '@services/requestInsured.service';
import { PolicyService } from '@services/policy.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ContractService } from '@services/contract.service';
import { ContractProcessService } from '@services/contractProcess.service';
import { UploadService } from '@services/core/upload.service';
import { RequestService } from '@services/request.service';
import { canGeneratePayroll } from 'app/utils/role-rules';

@Component({
  selector: 'app-search-payroll',
  standalone: true,
  imports: [CommonModule, NgbNavModule, FormsModule, NumberPipe, NgbTooltipModule, ReviewPayrollComponent, ReviewRequestComponent, NgSelectComponent],
  providers: [PolicyService, ContractService, ContractProcessService, UploadService, ReportService ],
  templateUrl: './search-payroll.component.html',
  styleUrls: ['./search-payroll.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SearchPayrollComponent implements OnInit {

  private today = new Date()
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  private _policyService = inject(PolicyService)
  private _contractService = inject(ContractService)
  private _contractProcessService = inject(ContractProcessService)
  private _reportService = inject(ReportService)
  protected _userService = inject(UserService)

  protected listCoverages: any[] = []
  protected coverageSelected: any

  private listPayrollsTemp: any[] = []
  private modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })

  private modalService = inject(NgbModal)

  protected levelRole = 100
  protected get canGenerate(): boolean {
    return canGeneratePayroll((this._userService.sharingRole() as any)?.priority)
  }
  protected payrollSel: any
  protected actualMonth: any

  protected listPayrolls: any[]
  protected listPoliciesByCoverages: any
  protected searchType = 2
  protected contractSel: any
  protected requestSel: any

  public cod: any
  public dateSince: any
  public find: any


  public closeResult = ""

  rowClass(d: any): string {
    const classes: string[] = []
    if (d.insured.age >= 65 && d.relationship.code == 'T') classes.push('bg-pink-100')
    if (d.movement?.class) classes.push(d.movement.class)
    return classes.join(' ')
  }

  badgeClass(movementClass: string): string {
    const map: any = {
      'table-warning': 'bg-warning text-dark',
      'table-success': 'bg-success text-white',
      'table-danger': 'bg-danger text-white',
      'table-primary': 'bg-primary text-white',
      'table-secondary': 'bg-secondary text-white',
    }
    return map[movementClass] || 'bg-light text-dark'
  }

  ngOnInit(): void {
    const day = this.today.getDate()
    const offset = day > 20 ? 1 : 0
    const target = new Date(this.today.getFullYear(), this.today.getMonth() + offset, 1)
    const year = target.getFullYear()
    const month = target.getMonth() + 1
    this.dateSince = year + "-" + (month < 10 ? "0" + month : month)
    this.actualMonth = this.dateSince
    this.getCoverages()
  }

  open(modal: any) {
    this.modalService.open(modal, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  getCoverages() {
    this._policyService.getCoverages().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listCoverages = res
      this.coverageSelected = res[0]._id
      this.cdr.markForCheck()
    })
  }

  getPayrolls() {
    this._contractService.getByCoverage(this.coverageSelected, this.dateSince).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.searchType = 1
      this.listPoliciesByCoverages = res
      this.cdr.markForCheck()
    })
  }

  getByEntity(entity: any, policy: any) {
    this._contractService.getByEntity(entity, policy, this.dateSince).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listPayrolls = res
      this.searchType = 2
      this.cdr.markForCheck()
    })
  }

  getByPolicy(policy: any) {
    this._contractService.getByPolicy(policy, this.dateSince).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listPayrolls = res
      this.listPayrollsTemp = res
      this.payrollSel = { policy: res[0].policy, period: res[0].period }
      this.searchType = 3
      this.cdr.markForCheck()
    })
  }

  getByPolicyAndCampus(campus: any) {
    this._contractService.getByPolicyAndCampus(campus["group.campus._id"], campus.policyId, this.dateSince).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listPayrolls = res
      this.listPayrollsTemp = res
      this.payrollSel = { policy: res[0].policy, period: res[0].period, campusId: campus["group.campus._id"] }
      this.searchType = 3
      this.cdr.markForCheck()
    })
  }

  openContract(modal: any, contract: any) {
    this.contractSel = contract
    this.open(modal)
  }

  openRequest(modal: any, request: any) {
    Swal.fire({
      text: "Buscando Datos...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    })

    this.requestSel = request
     this.open(modal)
    
  }

  filterSearch() {

    if (this.find.length >= 3) {
      // Primero, filtrar los registros por nombre
      const filteredByName = this.listPayrollsTemp.filter(l => {
        const name = l.insured.names + " " + l.insured.surname + " " + l.insured.lastname;
        return name.toLowerCase().includes(this.find.toLowerCase());
      });
      const listIDs = filteredByName.map(f => f.holder._id)
      this.listPayrolls = this.listPayrollsTemp.filter(l => listIDs.includes(l.holder._id) );
      this.sortFinded()
    } else {
      this.listPayrolls = this.listPayrollsTemp
    }
  }

  sortFinded() {
    const groupedData = this.listPayrolls.reduce((acc, a) => {
      const group = acc.find((g: any) => g[0].holder._id === a.holder._id);

      if (!group) {
        acc.push([a]);
      } else {
        group.push(a);
      }

      return acc;
    }, []);
    groupedData.forEach((group: any) => {
      group.sort((x: any, y: any) => x.type.index - y.type.index);
    });
    this.listPayrolls = groupedData.flat();
  }

  exportExcel(periodSelected: any) {
    Swal.fire({
      text: "Generando Archivo...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => { Swal.showLoading(); },
    })
    this._reportService.generateExcel(this.payrollSel).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      const date = new Date(this.payrollSel.period)
      const month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      const timestamps = Math.round(new Date().getTime() / 1000)
      a.href = url;
      a.download = `NV_00${this.payrollSel.policy.code}_A${date.getFullYear()}M${month}T${timestamps}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      Swal.close()
    })
  }

  async getUF() {
    Swal.fire({
      text: "Buscando Datos UF...",
      didOpen: () => { Swal.showLoading(); },
    })
    try {
      const res = await firstValueFrom(this._contractService.getUF(this.dateSince))
      Swal.close()

      const period = {
        year: this.dateSince.split("-")[0],
        month: this.dateSince.split("-")[1]
      }
      const coverage = this.listCoverages.find(c => c._id == this.coverageSelected)

      const result = await Swal.fire({
        title: `Generando cobranzas de '${coverage?.name}'`,
        text: `Se generara la cobranza del periodo: ${period.month}-${period.year} con el valor de UF: $${res.precio}`,
        confirmButtonColor: "#3B71CA",
        confirmButtonText: "Generar",
        showCancelButton: true,
        cancelButtonColor: "#DC4C64",
        cancelButtonText: "Cancelar",
        allowEscapeKey: false,
        allowOutsideClick: false
      })

      if (result.isConfirmed) {
        await this.generatePayroll(res.precio)
      }
    } catch (err: any) {
      Swal.close()
      const msg = err.error?.error || err.error?.msg || err.message || "Error en el proceso"
      this.notifyError(msg)
    }
  }

  private escapeHtml(str: string): string {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;')
  }

  private progressHtml(pct: number, label: string, detail = ''): string {
    const safeLabel = this.escapeHtml(label)
    const safeDetail = detail ? this.escapeHtml(detail) : ''
    return `
      <div style="text-align:left;margin-bottom:6px;font-size:14px">${safeLabel}</div>
      <div class="progress" style="height:20px">
        <div class="progress-bar progress-bar-striped progress-bar-animated"
             role="progressbar" style="width:${pct}%">${Math.round(pct)}%</div>
      </div>
      ${safeDetail ? `<div style="text-align:right;font-size:12px;margin-top:4px;color:#666">${safeDetail}</div>` : ''}
    `
  }

  private async withProgress(label: string, fn: () => Promise<any>) {
    Swal.fire({
      title: this._progressTitle,
      html: this.progressHtml(0, label),
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: false,
      showConfirmButton: false,
    })
    await fn()
    Swal.update({ html: this.progressHtml(100, label, 'Completado') })
  }

  private async withProgressChunked(label: string, chunkSize: number, fn: (offset: number) => Promise<any>) {
    let offset = 0
    Swal.fire({
      title: this._progressTitle,
      html: this.progressHtml(0, label),
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: false,
      showConfirmButton: false,
    })
    do {
      const r = await fn(offset)
      const total = r.totalChunk || 0
      const pct = total > 0 ? (r.processed / total) * 100 : 100
      Swal.update({ html: this.progressHtml(pct, label, `${r.processed}/${total}`) })
      if (r.done || total === 0) break
      offset = r.nextOffset
    } while (true)
  }

  private _progressTitle = ''

  /**
   * Genera registros iniciales, procesa solicitudes y calcula cobranzas.
   * El orden debe ser: generateInit → processRequests → calculatePayroll
   * para que syncDependents corra después de calculateModify.
   */
  async generatePayroll(uf: any) {
    this._progressTitle = 'Generando Nóminas'
    try {
      await this.withProgress('Generando registros iniciales...', () =>
        firstValueFrom(this._contractProcessService.generateInit(this.coverageSelected, this.dateSince, uf)))

      await this.withProgress('Procesando solicitudes...', () =>
        firstValueFrom(this._contractProcessService.processRequests(this.coverageSelected, this.dateSince)))

      await this.calculatePayroll()
    } catch (err) {
      this.handleGenerateError(err)
    }
  }

  /**
   * Ejecuta la cadena completa de cálculos de cobranza:
   * init → incorporaciones → modificaciones → syncDependents → coveredLives → normal.
   * syncDependents debe ir después de calculateModify para no ser sobreescrito.
   */
  async calculatePayroll() {
    this._progressTitle = 'Calculando Cobranzas'
    try {
      await this.withProgress('Calculando init...', () =>
        firstValueFrom(this._contractProcessService.calculateInit(this.coverageSelected, this.dateSince)))

      await this.withProgress('Calculando incorporaciones...', () =>
        firstValueFrom(this._contractProcessService.calculateIncorporation(this.coverageSelected, this.dateSince)))

      await this.withProgress('Calculando modificaciones...', () =>
        firstValueFrom(this._contractProcessService.calculateModify(this.coverageSelected, this.dateSince)))

      await this.withProgressChunked('Sincronizando cargas familiares...', 50, o =>
        firstValueFrom(this._contractProcessService.syncDependents(this.coverageSelected, this.dateSince, o, 50)))

      await this.withProgress('Actualizando cargas familiares...', () =>
        firstValueFrom(this._contractProcessService.generateCoveredLives(this.coverageSelected, this.dateSince)))

      await this.withProgressChunked('Calculando cobranzas normales...', 3500, o =>
        firstValueFrom(this._contractProcessService.calculateNormal(this.coverageSelected, this.dateSince, o, 3500)))

      Swal.close()
      this.notifySuccess("Cobranzas generadas y calculadas correctamente")
      this.getPayrolls()
    } catch (err) {
      this.handleGenerateError(err)
    }
  }

  private handleGenerateError(err: any) {
    Swal.close()
    console.warn(err)
    const msg = err.error?.error || err.error?.msg || err.message || "Error en el proceso"
    this.notifyError(msg)
  }

  private notifySuccess(msg: any) {
    this.Toast.fire({ text: msg, timer: 6000, icon: "success" })
  }

  private notifyError(msg: any) {
    this.Toast.fire({ text: msg, timer: 6000, icon: "error" })
  }

}
